// extracted by mini-css-extract-plugin
export var cell = "_66-4";
export var headerCell = "_66-2";
export var rowHeader = "_66-3";
export var table = "_66-1";
export var tableContainer = "_66-0";